import BackButton from "~/screens/Auth/components/BackButton";
import { DurationDisplay } from "~/screens/Scheduling/InitialVisit/components/DurationDisplay";
import { VISIT_TYPES, VisitType } from "~/services";
import { Logo } from "~/shared";
import { getVisitTypeTitle } from "~/utils";

type HeaderProps = {
  visitType: VisitType;
  handleGoBack: () => void;
};

export const Header = ({ visitType, handleGoBack }: HeaderProps) => {
  const visitTitle = getVisitTypeTitle(visitType).toLowerCase();

  const backButtonText =
    visitType === VISIT_TYPES.FOLLOW_UP ? "View all clinicians" : "Back";

  return (
    <>
      <div className="flex w-3/4 p-4 md:self-center">
        <Logo className="block h-8 md:h-10" />
      </div>
      <header className="px-4 md:hidden">
        <BackButton
          variant="violet"
          handleGoBack={handleGoBack}
          text={backButtonText}
        />
        <div className="flex flex-col gap-2">
          <h1 className="text-indigo font-ivy lg:text-4-5xl text-3xl font-light">
            Let's book your {visitTitle}
          </h1>

          <div className="flex flex-wrap items-center gap-3">
            <DurationDisplay visitType={visitType} />
          </div>
        </div>
      </header>
    </>
  );
};
